// extracted by mini-css-extract-plugin
export default {"SelectPs":"CustomSelector_SelectPs__SJRbk","legend":"CustomSelector_legend__BJnuN"};